










































































































































import { Component, Mixins, Prop, Inject } from "vue-property-decorator";
import AdminBrands from "@/mixins/adminBrands";
import ClientMixin from "@/mixins/clientMixin";
import {
  IClientsProvider,
  IClientsProviderMethods
} from "@/models/providers/client";

@Component({
  components: {
    "add-segment-message": () =>
      import("@/components/app/admin/segments/addSegmentMessage.vue"),
    "client-tags": () => import("@/components/app/global/client/clientTags.vue")
  }
})
export default class ClientsTable extends Mixins(AdminBrands, ClientMixin) {
  // Inject

  @Inject({ from: "clientsProvider" })
  public clientsProvider!: () => IClientsProvider;

  @Inject({ from: "clientsProviderMethods" })
  public $clientsMethods!: IClientsProviderMethods;

  // Props

  @Prop({ default: false })
  public isPaginated!: boolean;

  // Computed

  public get $clientsData() {
    return this.clientsProvider();
  }
}
